<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    ref="gc-base-layout"
    class="remittance-distribution"
    :tabs="getTabs"
    :selectedIndex="screenSelectedIndex"
  >
    <slot> </slot>
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="'Bank Reconciliation'"
        :createModeIsEditMode="true"
        :baseView="baseView"
        :primaryLabel="getScreenTitle"
        :secondaryLabel="undefined"
        v-if="loaded"
      />
    </template>
    <div class="css-v2 transaction-screen" v-if="loaded">
      <div class="gc-header-toolbar">
        <gc-form-header-toolbar
          :toolbar-options="getHeaderToolbar"
          :data-model="loaded ? dataModel : {}"
          :backRoute="backButtonRoute"
          :setLoading="showLoading"
          ref="gc-form-header-toolbar"
          :baseView="baseView"
        ></gc-form-header-toolbar>
      </div>

      <div class="gc-header-form" v-show="!gridExpand">
        <div class="header-form">
          <div class="view-card responsive-paddings">
            <gc-form
              :formOptions="{
                gcLabelLocation: 'left',
              }"
              :formItems="getHeaderFormItems"
              :isNormal="true"
              :data-model="loaded ? dataModel : {}"
              :formMode="baseView.mode"
              :fromFrom="'gc-header-form'"
              ref="gc-header-form"
              :validationGroup="'gc-header-form'"
              :scrollingEnabled="false"
              :formHeight="100"
              :formContentReady="onHeaderFormContentReady"
            ></gc-form>
          </div>
        </div>
      </div>

      <div class="gc-details-grid" v-if="loaded">
        <gc-filter-split-view
          :showLeftContainer="showLeftContainer"
          :showRightContainer="showRightContainer"
          :rightContainerWidth="250"
        >
          <template #leftContent>
            <dx-data-grid
              :height="getGridHeight"
              :columns="getGridColumns"
              :data-source="getDataSource"
              @toolbar-preparing="toolbarPreparing($event)"
              :column-chooser="{
                enabled: false,
              }"
              ref="remittance-distribution-grid"
              @selection-changed="onGridSelectionChanged"
              :sorting="{
                mode: 'multiple',
              }"
            >
              <DxSelection
                :select-all-mode="'allPages'"
                :show-check-boxes-mode="'always'"
                mode="multiple"
              />
              <template #Record="{ data }">
                <GcRecord
                  :data="data"
                  :primary="data.column['cellTemplateRecord']['primary']"
                  :secondary="data.column['cellTemplateRecord']['secondary']"
                />
              </template>
              <template #Status="{ data }">
                <GcStatusChip
                  :status="data.data[data.column.dataField]"
                  v-if="data.data[data.column.dataField]"
                />
              </template>
            </dx-data-grid>
          </template>
          <template #rightContent>
            <div
              class="advance-filter-panel"
              :key="'fpanel-bank-reconciliation-tree'"
            >
              <DxToolbar class="split-view-toolbar">
                <dx-item
                  location="before"
                  widget="dxTabs"
                  :options="filterPanelTabOptions"
                  selected-index="0"
                ></dx-item>

                <DxItem
                  :options="filterToolbar.clear"
                  location="after"
                  locate-in-menu="auto"
                  widget="dxButton"
                  :visible="false"
                />

                <DxItem
                  :options="filterToolbar.close"
                  location="after"
                  widget="dxButton"
                />
              </DxToolbar>
              <gc-filter-panel
                :toolbarVisible="false"
                :formItemData="filterFormItems"
                :setGridPanelFilter="setGridPanelFilter"
                :gridFoolter="showFooter"
                :showLoading="showLoading"
                :from="'stand-alone'"
                :isNormal="false"
                :key="'fp-bank-reconciliation-tree'"
                :overWriteClear="true"
              >
              </gc-filter-panel>
            </div>
          </template>
        </gc-filter-split-view>
      </div>
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import { BatchPaymentService } from "../../_services/api/suppliers/batch-payment-service";
import { mapGetters } from "vuex";
import ArrayStore from "devextreme/data/array_store";
export default {
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  data() {
    return {
      screenSelectedIndex: 1,
      loaded: false,
      dataModel: {},
      gridExpand: false,

      showLeftContainer: true,
      showRightContainer: true,
      headerFormHeight: 0,

      localDataSource: new ArrayStore({
        key: "ID",
        data: [],
      }),

      filterToolbar: {
        close: {
          icon: "showpanel",
          onClick: () => {
            this.closeFilterPanel();
          },
          // visible: browserHelper.tablet,
        },
        clear: {
          text: "Clear",
          onClick: () => {
            this.clearAdvanceFilters();
          },
        },
      },
      showFooter: false,
      enableEmailOption: false,
      enablePrintOption: false,
    };
  },
  async created() {
    this.showLoading(true);
    await this.initialized();
    this.loaded = true;
    this.showLoading(false);
  },
  methods: {
    backButtonFunction() {
      this.$router
        .push({
          path: this.backButtonRoute,
        })
        .then(() => {
          this.$store.dispatch("dataContext/setDataViewType", undefined);
        });
    },
    async initialized() {
      await BatchPaymentService.getBatchPaymentRun(this.baseView.id).then(
        (res) => {
          let data = res.data.value[0];
          this.dataModel.DateIn = new Date(data.TransactionDate);
          this.dataModel.BankAccount = data.BankAccountCode.toString();
          this.dataModel.PaymentDate = new Date(data.PaymentDate);
          this.dataModel.Reference = data.Reference;
          this.dataModel.DueDate = new Date(data.DueBeforeDate);
          this.dataModel.SupplierType =
            data.BatchPaymentSupplierTypeFilters.map((x) => x.SupplierTypeCode);
          this.dataModel.SupplierCode = data.BatchPaymentSupplierFilters.map(
            (x) => x.SupplierCode
          );
          if (data.Status == "A") {
            this.dataModel.Status = "O";
          } else {
            this.dataModel.Status = data.Status;
          }
        }
      );

      this.getRemittanceDistribution();
    },
    async getRemittanceDistribution() {
      await BatchPaymentService.getRemittanceDistribution(
        this.baseView.id
      ).then((res) => {
        if (res.data.value.length > 0) {
          res.data.value.forEach((element) => {
            this.localDataSource.insert(element);
          });
        }
      });
    },
    onHeaderFormContentReady() {
      const headerForm = document.querySelectorAll(".gc-header-form");
      this.headerFormHeight = headerForm[0].clientHeight;
    },

    toolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });

      let itemsToRemoveFromToolBar = ["searchPanel"];

      e.toolbarOptions.items = toolbarItems.filter(
        (item) => !itemsToRemoveFromToolBar.includes(item.name)
      );

      searchPanel.location = "after";
      e.toolbarOptions.items.unshift(
        searchPanel,
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            tabIndex: -1,
            icon: "email",
            onClick: () => {
              this.saveEmailPrint("Email");
            },
            disabled: !this.enableEmailOption,
          },
        },
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            tabIndex: -1,
            icon: "print",
            onClick: () => {
              this.saveEmailPrint("Print");
            },
            disabled: !this.enablePrintOption,
          },
        },
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            tabIndex: -1,
            icon: this.gridExpand ? "collapse" : "expand",
            onClick: () => {
              this.gridExpand = !this.gridExpand;

              setTimeout(() => {
                this.reSizeGrid();
              }, 100);
            },
          },
        },
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            icon: "filter",
            elementAttr: { id: "filter-btn" },
            onClick: () => {
              this.showRightContainer = !this.showRightContainer;
              var item = document.getElementById("filter-btn");
              this.$logger.debug("item ", item);
              item.classList.add("dx-state-invisible");

              setTimeout(() => {
                this.reSizeGrid();
              }, 50);
            },
            visible: !this.showRightContainer,
          },
        }
      );
    },
    onGridSelectionChanged(e) {
      let grid = e.component;
      if (e.selectedRowsData.length > 0) {
        let emails = e.selectedRowsData.filter((x) => x.SupplierContactEmail);
        let refresh = false;
        if (emails.length > 0) {
          if (!this.enableEmailOption) {
            this.enableEmailOption = true;
            refresh = true;
          }
        } else {
          if (this.enableEmailOption) refresh = true;
          this.enableEmailOption = false;
        }

        if (!this.enablePrintOption) refresh = true;
        this.enablePrintOption = true;

        if (refresh) grid.repaint();
      } else {
        this.enablePrintOption = false;
        this.enableEmailOption = false;
        grid.repaint();
      }
    },

    // Filter Panel
    closeFilterPanel() {
      this.showRightContainer = !this.showRightContainer;

      var item = document.getElementById("filter-btn");
      item.classList.remove("dx-state-invisible");

      setTimeout(() => {
        this.reSizeGrid();
      }, 50);
    },

    setGridPanelFilter(filters, valueChanged) {
      let dataGrid = this.$refs["remittance-distribution-grid"].instance;
      if (valueChanged != undefined || filters.length > 0) {
        if (filters.length > 0) dataGrid.filter(filters);
        else if (filters.length == 0) dataGrid.clearFilter();
        dataGrid.refresh(true);
      }
      this.showLoading(false);
    },

    reSizeGrid() {
      let grid = this.$refs["remittance-distribution-grid"].instance;
      if (grid) {
        grid.beginUpdate();
        grid.updateDimensions();
        grid.endUpdate();
      }
    },
    async saveEmailPrint(type) {
      let grid = this.$refs["remittance-distribution-grid"].instance;
      let selectedRows = grid.getSelectedRowsData();

      let payload = {
        RunId: this.baseView.id,
        Action: type,
        RemittanceDistributionRunDetails: selectedRows.map((x) => {
          return {
            RunId: x.RunId,
            SupplierContactRecordId: x.SupplierContactRecordId,
          };
        }),
      };

      this.showLoading(true);
      await BatchPaymentService.saveRemittanceDistribution(payload)
        .then(async (res) => {
          if (res) this.localDataSource.clear();
          await this.getRemittanceDistribution();

          let grid = this.$refs["remittance-distribution-grid"].instance;
          if (grid) {
            grid.deselectAll();
            grid.refresh(true);
          }
          this.showLoading(false);
        })
        .catch((err) => {
          this.showLoading(false);
          this.displayServerError(err, "Email / Print Failed");
        });
    },
  },
  computed: {
    // Filter Panel
    filterPanelTabOptions() {
      return {
        dataSource: [
          {
            id: 0,
            text: "Filters",
          },
        ],
        selectedIndex: 0,
      };
    },

    filterFormItems() {
      return [
        {
          type: "Text",
          screenField: "Supplier",
          filterDataField: "SupplierSearchText",
        },
        {
          screenField: "EmailStatus",
        },
        {
          screenField: "PrintStatus",
        },
      ];
    },

    getGridColumns() {
      return this.parseGridColumns([
        {
          screenField: "Supplier",
          cellTemplateRecord: {
            primary: [
              {
                dataField: "SupplierName",
              },
            ],
            secondary: [
              {
                dataField: "SupplierCode",
              },
            ],
          },
          sortOrder: "asc",
          sortIndex: 0,
        },
        {
          screenField: "SupplierReference",
          caption: "Contact",
          dataField: "SupplierContactName",
          sortOrder: "asc",
          sortIndex: 1,
        },
        {
          screenField: "Email",
          dataField: "SupplierContactEmail",
        },
        {
          screenField: "EmailStatus",
        },
        {
          screenField: "PrintStatus",
        },
      ]);
    },
    getDataSource() {
      return this.localDataSource._array;
    },
    ...mapGetters({ gridHeight: "ui/getHeightForDataGrid" }),
    getGridHeight() {
      return this.gridHeight - 75 - this.headerFormHeight;
    },
    getHeaderFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 2,
          items: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  screenField: "DateIn",
                  dataField: "DateIn",
                },
                {
                  screenField: "BankAccount",
                  dataField: "BankAccount",
                  label: {
                    text: "Bank Account",
                  },
                  required: true,
                  dataSourceConfig: {
                    endpoint: "api/BankRecord",
                    sort: {
                      selector: "AccountName",
                      asc: true,
                    },
                  },
                },
                {
                  screenField: "Reference",
                  dataField: "Reference",
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  screenField: "DueDate",
                  dataField: "DueDate",
                  label: {
                    text: "Due Before",
                  },
                },
                {
                  screenField: "SupplierType",
                  dataField: "SupplierType",
                  label: {
                    text: "Supplier Type",
                  },
                  editorOptions: {
                    showClearButton: true,
                    showSelectionControls: true,
                    select: ["Inactive", "Code", "Description"],
                  },
                  required: false,
                  editorType: "dxTagBox",
                },
                {
                  screenField: "ApremitCreateSuppliers",
                  dataField: "SupplierCode",
                  label: {
                    text: "Supplier",
                  },
                  editorOptions: {
                    showClearButton: true,
                    showSelectionControls: true,
                    select: ["AutoCHQ", "SupplierCode", "SupplierName"],
                    allowUpdate: this.allowPaymentRunGeneration,
                  },
                  required: false,
                  editorType: "dxTagBox",
                },
              ],
            },
          ],
        },
      ];
    },
    getScreenTitle() {
      return `Batch Payment Run #${this.baseView.id}`;
    },
    backButtonRoute() {
      if (this.baseView.query && this.baseView.query.from) {
        return this.baseView.query.from;
      } else return "/supplier/batch-payment-list";
    },
    getTabs() {
      return [
        {
          text: "Details",
          path:
            `/supplier-batch-payment/` +
            this.baseView.mode +
            "/" +
            this.baseView.id,
          applicationFeatureCode: "BatchPaymentSave",
        },
        {
          text: "Remittance Distribution",
          path: `/remittance-distribution/review/` + this.baseView.id,
          applicationFeatureCode: "BatchPaymentSave",
        },
      ];
    },

    getHeaderToolbar() {
      return {
        screenName: "Batch Payment",
        pdf: false,
        audit: false,
        status: false,
        notes: false,
        save: false,
      };
    },
  },
};
</script>

<style lang="scss">
.remittance-distribution {
  .gc-header-form .header-form {
    margin-bottom: unset !important;
  }
}
</style>